import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Tooltip, Circle } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { mapService, suggestionService } from '../services/api';

// Fijar ícono por defecto (Leaflet no lo carga bien en CRA)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7/dist/images/marker-shadow.png',
});

export default function MapInteractive({isAdmin}) {
  const [districts, setDistricts] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [districtsResponse, suggestionsResponse] = await Promise.all([
          mapService.getDistricts(),
          suggestionService.getSuggestions()
        ]);
        setDistricts(districtsResponse.data);
        setSuggestions(suggestionsResponse.data);
      } catch (err) {
        console.error('Error loading map data:', err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const counts = {};
  districts.forEach(d => (counts[d.id] = 0));
  suggestions.forEach(s => {
    counts[s.district] = (counts[s.district] || 0) + 1;
  });

  useEffect(() => {
    document.documentElement.style.setProperty('--primary', '#69c24d'); // verde SPT
  }, []);

  if (loading) return <div className="text-center py-12">Cargando mapa...</div>;
  if (error) return <div className="text-center py-12 text-red-600">{error}</div>;
  if (!districts?.length) return null;

  if(!isAdmin) return null;

  return (
    <section className="my-8 bg-white p-4 rounded shadow-sm">
      <h3 className="text-lg font-semibold mb-3">Mapa interactivo de La Guardia</h3>

      <MapContainer
        center={[-17.9, -63.35]}
        zoom={12.3}
        scrollWheelZoom={true}
        className="w-full rounded-md"
        style={{ height: '400px', zIndex: 0 }}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {districts.map((d) => (
          <Marker key={d.id} position={d.coords}>
            <Tooltip direction="top" offset={[0, -10]} opacity={1} permanent>
              <div className="text-sm font-semibold">{d.name}</div>
              <div className="text-xs text-gray-700">
                Participación: {d.participants} personas
              </div>
            </Tooltip>
          </Marker>
        ))}

        {/* Círculos de intensidad solo en modo admin */}
        {isAdmin &&
          Object.keys(counts).map((k) => {
            const d = districts.find((dd) => dd.id === k);
            const c = counts[k] || 0;
            if (!d) return null;
            const radius = 200 + c * 100;
            return (
              <Circle
                key={k}
                center={d.coords}
                radius={radius}
                pathOptions={{ color: '#69c24d', fillColor: '#69c24d', fillOpacity: 0.2 }}
              />
            );
          })}
      </MapContainer>

      <div className="mt-3 text-sm text-gray-600">
        Selecciona un distrito para ver actividades y líderes.
      </div>
    </section>
  );
}
